import { useRef } from 'react';
/**
 * Returns a ref that is immediately updated with the new value
 *
 * @param value The Ref value
 */

export default function useUpdatedRef(value) {
  var valueRef = useRef(value);
  valueRef.current = value;
  return valueRef;
}